import { resources as en } from 'locales/en/resources';
import { resources as fr } from 'locales/fr/resources';

export const resources = {
  en,
  fr,
} as const;
